export default {
  title: {
    fontWeight: 500,
    fontSize: 22,
    display: 'flex',
    alignItems: 'center',
    color: 'rgba(0, 0, 0, 0.9)',
  },
  info: {
    padding: 6,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12,
  },
  subInfo: {
    paddingLeft: 6,
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.541176)',
  },
  header: {
    marginTop: 16,
    paddingLeft: 0,
    fontSize: 20,
    fontWeight: '300',
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
  },
  appraisal: {
    marginTop: 16,
    padding: 6,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  content: {
    margin: 6,
    fontSize: 20,
  },
  date: {
    padding: 12,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 18,
    color: 'rgba(0, 0, 0, 0.541176)',
    flexWrap: 'wrap',
  },
};



// WEBPACK FOOTER //
// ./src/styles/AppraisalList.js